import type { StripeAccountInfo } from '@pflegenavi/shared/api';
import type { CreateStripeAccountResponse } from '@pflegenavi/shared/api';

export const ServiceProviderPaymentsStripeAccountControllerDefinition = {
  controller: 'service-provider/payments/stripe-account',
  endpoints: {
    getServiceProviderStripeAccount: {
      method: 'GET',
      url: ':globalServiceProviderId',
      response: undefined as unknown as
        | StripeAccountInfo
        | { stripeAccountId: undefined },
      body: undefined,
    },
    createServiceProviderStripeAccount: {
      method: 'POST',
      url: ':globalServiceProviderId',
      response: undefined as unknown as CreateStripeAccountResponse,
      body: undefined,
    },
    refetchServiceProviderStripeAccount: {
      method: 'POST',
      url: ':globalServiceProviderId/refetch',
      response: undefined as unknown as StripeAccountInfo,
      body: undefined,
    },
  },
} as const;

export type ServiceProviderPaymentsStripeAccountControllerResultTypes = {
  [key in keyof (typeof ServiceProviderPaymentsStripeAccountControllerDefinition)['endpoints']]: (typeof ServiceProviderPaymentsStripeAccountControllerDefinition)['endpoints'][key]['response'];
};
export type ServiceProviderPaymentsStripeAccountControllerBodyTypes = {
  [key in keyof (typeof ServiceProviderPaymentsStripeAccountControllerDefinition)['endpoints']]: (typeof ServiceProviderPaymentsStripeAccountControllerDefinition)['endpoints'][key]['body'];
};
